module.exports = __webpack_public_path__ + "static/img/c1.6c6874c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/c1.png
// module id = wsmQ
// module chunks = 1